import React, { Component } from "react";

import { Container } from "components/Grid";
import Slider from "components/Slider";
import Tabs, { Tab } from "components/Tabs";
import Button from "components/Button";

import { Inner } from "./styles";
import Person from "./Person";

class Teams extends Component {
  state = {
    slide: 1
  };

  handleTab = slide => {
    this.slider && this.slider.slickGoTo(slide);
  };

  render() {
    const { slide } = this.state;
    const { content } = this.props;

    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      adaptiveHeight: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: slide,
      beforeChange: (current, next) => this.setState({ slide: next })
    };

    return (
      <>
        <Tabs pt={["30px", "70px"]}>
          {content.map((section, index) => (
            <Tab
              key={index}
              active={slide === index}
              onClick={() => this.handleTab(index)}
            >
              {section.name}
            </Tab>
          ))}
        </Tabs>
        <Slider innerRef={ref => (this.slider = ref)} {...settings}>
          {content.map((section, index) => (
            <Inner key={index}>
              {section.people.map((person, index) => (
                <Person key={index} content={person} />
              ))}
            </Inner>
          ))}
        </Slider>
      </>
    );
  }
}

export default Teams;
